import { render, staticRenderFns } from "./Content_Component.vue?vue&type=template&id=df8ac066&scoped=true&"
import script from "./Content_Component.vue?vue&type=script&lang=js&"
export * from "./Content_Component.vue?vue&type=script&lang=js&"
import style0 from "./Content_Component.vue?vue&type=style&index=0&id=df8ac066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8ac066",
  null
  
)

export default component.exports